import { render, staticRenderFns } from "./ItemBrandForm.vue?vue&type=template&id=5b694821"
import script from "./ItemBrandForm.vue?vue&type=script&lang=js"
export * from "./ItemBrandForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports